import React from "react";
import { Typography, Box } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { useSelector } from "react-redux";
import { useRccTypography } from "./typography";
import { rccColors } from "./colors";

const useStyles = makeStyles((theme) => ({
  header: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: "2px",
    flex: "1 0 0",
  },
}));

function RccHeader() {
  const classes = useStyles();
  const typography = useRccTypography();
  const user = useSelector((state) => state.app?.user);

  // Construct userName from firstName and lastName, fallback to default
  const userName =
    user?.firstName && user?.lastName
      ? `${user.firstName} ${user.lastName}`
      : user?.userName || "User";

  // Use Value_Label as company name if available, fallback to default
  const companyName = user?.companyName || "Company";

  return (
    <Box className={classes.header}>
      <Typography
        className={typography.displaySmallSemibold}
        style={{ color: rccColors.neutral[900] }}
      >
        Hello {userName}
      </Typography>
      <Typography
        className={typography.textMediumRegular}
        style={{ color: rccColors.neutral[500] }}
      >
        Here's how {companyName} is doing
      </Typography>
    </Box>
  );
}

export default RccHeader;
